import { EmployeeAttributeValidationRequestType } from "@/constants";
import { parseISO } from "date-fns";
import isEmpty from "lodash/isEmpty";
import { Utils } from "../../common/Utils";
import { IChecklists } from "../../interfaces/CheckLists";
import { AbstractAttributeBase } from "./AbstractAttributeBase";
import { AttributeRequestActivity } from "./AttributeRequestActivity";
// export class EmployeeAttribute extends AbstractAttribute {
export class EmployeeAttribute extends AbstractAttributeBase {
  static status: any = {
    review: {
      label: "Under review",
      translationKey: "status.underReview"
    },
    feedback: {
      label: "Needs feedback",
      translationKey: "status.needsFeedback"
    },
    approved: {
      label: "Approved",
      translationKey: "status.approved"
    },
    declined: {
      label: "Declined",
      translationKey: "status.declined"
    }
  };

  lastUpdate: any;
  category: any;
  currentProficiency: any;
  statusLabel: any;
  validated: any;
  requestedProficiency: any;
  proficiency: any;
  validationRequest: any;
  validationRequestId: any;
  trainingCourses: any;
  notifications: any;
  checklistAnswers: IChecklists[] = [];
  checklists: any = [];
  practicalTrainingHours: number;
  validationRequestType: EmployeeAttributeValidationRequestType;
  [key: string]: any;

  constructor(index: any, data: any) {
    super(index, data);

    this.lastUpdate = data.lastUpdateDate;
    this.attributeName = data.attributeDefinitionName;
    this.attribute = data.attributeDefinitionName;
    this.category = data.attributeDefinitionCategory;
    this.currentProficiency = data.proficiencyValue;
    this.currentExpiryDate = data.expiryDate ? new Date(parseISO(data.expiryDate)) : undefined;

    this.status = Object.values(AbstractAttributeBase.status)[data.validationRequestState] || null;
    this.statusLabel = this.status ? this.status.label : "";
    this.employeeAttributeId = data.employeeAttributeId;
    this.validated = data.validated;
    this.requestedProficiency = data.validationRequest
      ? data.validationRequest.proficiencyValue
      : 0;
    this.requestedExpiryDate = data.validationRequest?.expiryDate
      ? new Date(parseISO(data.validationRequest.expiryDate))
      : null;

    this.proficiency = data.proficiencyValue;
    this.expiryDate = this.currentExpiryDate;
    this.validationRequest = data.validationRequest;
    this.validationRequestId = data.validationRequest
      ? data.validationRequest.employeeAttributeValidationRequestId
      : null;
    this.trainingCourses = data.trainingCourses;
    this.notifications = [];
    this.pendingExpiryDate = data.pendingExpiryDate
      ? data.pendingExpiryDate
      : this.requestedExpiryDate || this.currentExpiryDate;
    this.validationRequestState = isNaN(data.validationRequestState)
      ? data.validationRequestState
      : Object.values(AbstractAttributeBase.status)[data.validationRequestState];

    this.checklistAnswers = data.checklistAnswers || [];
    if (!isEmpty(data?.checklists)) {
      this.checklists = data.checklists
        ? data.checklists.map((c: IChecklists) => ({
            ...c,
            answers: Utils.getAnswersFromChecklist(c)
          }))
        : [];
    }
    this.practicalTrainingHours = data.practicalTrainingHours;
    this.validationRequestType = data.validationRequest?.requestType;
  }

  loadRequestActivity(context: any, updateCache: any) {
    return new Promise((resolve, reject) => {
      if (!this.requestActivity || updateCache === true) {
        this.requestActivity = new AttributeRequestActivity({
          attributeId: this.employeeAttributeId,
          resolve: (requestActivity: any) => {
            resolve(requestActivity);
          },
          reject,
          context
        });
      } else resolve(this.requestActivity);
    });
  }

  deleteChecklistAssignment(checklistAssignmentId: string) {
    this.checklists = this.checklists.filter((c: any) => c.assignmentId !== checklistAssignmentId);
  }
}
